import { render } from "./RankingCard.vue?vue&type=template&id=be1167f8&scoped=true"
import script from "./RankingCard.vue?vue&type=script&lang=js"
export * from "./RankingCard.vue?vue&type=script&lang=js"

import "./RankingCard.vue?vue&type=style&index=0&id=be1167f8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1167f8"]])

export default __exports__